import React, { useState, useEffect } from 'react';
import ReCAPTCHA from "react-google-recaptcha";

function RSVP({ currLang, user }) {
  {/*const [name, setName] = useState('')*/ }
  const [forms, setForms] = useState([
    {
      name: "",
      email: user?.email || "",
      beThere: "",
      food: ""
    }
  ]);
  const currUrl = window.location.origin
  const [captchaToken, setCaptchaToken] = useState('');
  const [message, setMessage] = useState('');
  const [isUpdate, setIsUpdate] = useState(false);

  useEffect(() => {
    if (user?.email) {
      // Fetch user name from backend
      fetch(`/api/user/${encodeURIComponent(user.email)}`)
        .then(res => res.json())
        .then(userData => {
          setForms(prevForms => {
            const updatedForms = [...prevForms];
            if (updatedForms[0]) {
              updatedForms[0].name = userData.name || "";
            }
            return updatedForms;
          });
        });

      // Fetch previous RSVPs
      fetch(`/api/rsvp/${encodeURIComponent(user.email)}`)
        .then(res => res.json())
        .then(data => {
          if (Array.isArray(data) && data.length > 0) {
            setForms(data);
            setIsUpdate(true);
          }
        });
    }
  }, [user]);

  const handleChange = (idx, e) => {
    const newForms = [...forms];
    newForms[idx][e.target.name] = e.target.value;
    setForms(newForms);
    setMessage("");
  };

  const addForm = () => {
    setForms([
      ...forms,
      { name: "", email: user?.email || "", beThere: "", food: "" }
    ]);
    setMessage("");
  };

  const removeForm = (idx) => {
    setForms(forms.filter((_, i) => i !== idx));
    setMessage("");
  };


  const handleSubmit = async e => {
    e.preventDefault();
    if (!captchaToken) {
      setMessage(currLang === "IS" ? "Vinsamlegast staðfestu að þú sért ekki vélmenni." : "Please verify you are not a robot.");
      return;
    }
    try {
      const res = await fetch('http://localhost:5001/api/rsvp/sync', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          submitter_email: user.email,
          entries: forms
        })
      });
      if (res.ok) {
        setMessage(currLang === "IS" ? "Tókst! Takk fyrir skráninguna." : "Success! Thank you for your RSVP.");
        // Refetch latest RSVPs and update state
        fetch(`/api/rsvp/${encodeURIComponent(user.email)}`)
          .then(res => res.json())
          .then(data => {
            if (Array.isArray(data) && data.length > 0) {
              setForms(data);
              setIsUpdate(true);
            }
          });
      } else {
        setMessage(currLang === "IS" ? "Villa við skráningu." : "Error submitting RSVP.");
      }
    } catch {
      setMessage(currLang === "IS" ? "Villa við tengingu." : "Connection error.");
    }
  };

  return (
    <div className='form-top' style={{ marginBottom: "2rem", padding: '1rem', maxWidth: '800px', margin: '0 auto' }}>
      <h1>RSVP</h1>
      <p>{currLang === "IS" ?
        <>
          Vinsamlegast fylltu út í spurningalistann hér að neðan til þess að skrá þig á gestalistann.<br />
          Við viljum biðja ykkur um að vinsamlegast skrá svör ykkar við RSVP spurningarlistanum eins fljótt og auðið er, en í síðasta lagi fyrir þann <strong>15. mars 2026</strong>. <br />
          Athugið, hægt er að breyta svörum ykkar fram að þeim tíma ef skoðanir breytast.
        </>
        :
        <>
          Please fill out the RSVP form to be added to the guestlist.<br />
          We kindly ask you to please submit your responses to the RSVP form as soon as possible, but no later than <strong>March 15th, 2026</strong>. <br />
          Note that it is possible to change your responses up until that date if opinions change.
        </>
      }</p>
      <p>{currLang === "IS" ?
        "Athugið, því fyrr sem þið skráið ykkur, því betra."
        :
        "The sooner you sign up, the better."
      }</p>
      <br />
      <form onSubmit={handleSubmit}>
        {forms.map((form, idx) => (
          <div key={idx} style={{ border: "2px solid #eee", padding: "1rem", marginBottom: "1rem", borderRadius: '10px' }}>
            <div className='form-group form-grid'>
              <label htmlFor={`name-${idx}`}>{currLang === "IS" ? "Fullt nafn" : "Full name"}</label>
              <input type="text"
                name="name"
                id={`name-${idx}`}
                value={form.name}
                onChange={e => handleChange(idx, e)}
                className='form-textbox'
                placeholder={currLang === "IS" ? "Fullt nafn" : "Full name"}
                onInvalid={(e) => e.currentTarget.setCustomValidity(currLang === "IS" ? "Þessi reitur verður að vera innfylltur" : "This field must be filled in")}
                onInput={(e) => e.currentTarget.setCustomValidity("")}
                required
              />
              <label htmlFor={`beThere-${idx}`}>{currLang === "IS" ? "Mætir þú?" : "Will you be there?"}</label>
              <select className="form-select" data-width="auto" aria-placeholder="" name="beThere" id={`beThere-${idx}`} value={form.beThere} onChange={e => handleChange(idx, e)} required>
                <option disabled value=""> -- {currLang === "IS" ? "Veldu Já/Nei" : "Choose Yes/No"} -- </option>
                <option className="select-control" value="Yes">{currLang === "IS" ? "Já auðvitað!" : "Yes of course!"}</option>
                <option className="select-control" value="Hmm">{currLang === "IS" ? "Óljóst" : "Uncertain"}</option>
                <option className="select-control" value="Noo">{currLang === "IS" ? "Nei :(" : "No :("}</option>
                <option className="select-control" value="NoButUpdateMe">{currLang === "IS" ? "Nei (en haltu mér samt á póstlistann)" : "No (but keep me on the mailing list)"}</option>
              </select>
              <label htmlFor={`email-${idx}`}>{currLang === "IS" ? "Tölvupóstfang" : "Email"}</label>
              {/*<input type="email" name="email" className='form-textbox' value={form.email} onChange={e => handleChange(idx, e)} placeholder={currLang === "IS" ? "Tölvupóstfang" : "Email address"}
                onInvalid={(e) => e.currentTarget.setCustomValidity(currLang === "IS" ? "Þessi reitur verður að vera innfylltur og innihalda tölvupóstfang" : "This field must be filled in and containing an email")}
                onInput={(e) => e.currentTarget.setCustomValidity("")}
                style={!!user ? { backgroundColor: '#f2f2f2', color: '#666', cursor: 'not-allowed' } : {}}
                required
                readOnly={!!user} />*/}
              <input
                type="email"
                name="email"
                className={`form-textbox${idx === 0 ? ' readonly-input' : ''}`}
                value={form.email}
                onChange={e => handleChange(idx, e)}
                placeholder={currLang === "IS" ? "Tölvupóstfang" : "Email address"}
                style={idx === 0 ? { backgroundColor: '#f2f2f2', color: '#666', cursor: 'not-allowed' } : {}}
                required
                readOnly={idx === 0}
              />

              <label htmlFor={`food-${idx}`}>{currLang === "IS" ? "Einhverjar matarvenjur?" : "Any dietery restrictions?"}</label>
              <input type="text"
                name="food"
                id={`food-${idx}`}
                value={form.food}
                onChange={e => handleChange(idx, e)}
                className='form-textbox'
                placeholder={currLang === "IS" ? "Engin mjólk eða eitthvað" : "No milk or something"}
              />
              {/*
          <label htmlFor='connection'>{currLang === "IS" ? "Tenging við brúðhjón?" : "Connection to bride and groom?"}</label>
          <select className="form-select" data-width="auto" aria-placeholder="" name="connection" value={form.connection} onChange={handleChange} required defaultValue={""}>
            <option disabled value=""> -- {currLang === "IS" ? "Veldu eitt" : "Pick one"} -- </option>
            <option className="select-control" value="FamBride">{currLang === "IS" ? "Fjölskylda brúðar" : "Family of bride"}</option>
            <option className="select-control" value="FamGroom">{currLang === "IS" ? "Fjölskylda brúðguma" : "Family of groom"}</option>
            <option className="select-control" value="FriendBride">{currLang === "IS" ? "Vinur brúðar" : "Friend of bride"}</option>
            <option className="select-control" value="FriendGroom">{currLang === "IS" ? "Vinur brúðguma" : "Friend of groom"}</option>
            <option className="select-control" value="FriendBoth">{currLang === "IS" ? "Vinur beggja" : "Friend of both"}</option>
            <option className="select-control" value="AnotherConn">{currLang === "IS" ? "Önnur óskilgreind tenging" : "Another undisclosed connection"}</option>
          </select>
*/}
            </div>
            {forms.length > 1 && idx !== 0 && (
              <button type="button" onClick={() => removeForm(idx)} style={{ marginTop: "0.5rem" }}>
                {currLang === "IS" ? "Fjarlægja þennan gest" : "Remove this guest"}
              </button>
            )}
          </div>
        ))}

        <button type="button" onClick={addForm} style={{ marginBottom: "1rem" }}>
          {currLang === "IS" ? "Bæta við öðrum gesti" : "Add another guest"}
        </button>

        <div className="recaptcha-center">
          <ReCAPTCHA
            sitekey="6Lfo3W4rAAAAAGy73McfDVAprcQcxGl-h8o7fyIh"
            onChange={token => setCaptchaToken(token)}
          />
        </div>
        <button type="submit" className='form-button'>{isUpdate ? (currLang === "IS" ? "Uppfæra svar" : "Update RSVP") : (currLang === "IS" ? "Senda svar" : "Send RSVP")}</button>
        {message && <p>{message}</p>}
      </form>

    </div>
  );
}

export default RSVP;
